(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("seedDataService", ["$http", seedDataService]);
    function seedDataService($http) {
        var seedDataServiceFactory = {};
        var seedData = function () {
            return $http({ method: "GET", url: "/api/seedData" });
        };
        seedDataServiceFactory.seedData = seedData;
        return seedDataServiceFactory;
    }
}());
